import { useSelector, useDispatch } from 'react-redux';
import { RootState } from 'store/ducks';
import React, { useState, useEffect } from 'react';
import { DateOutputStr } from 'utils/DateOutput';
import toast from 'components/Toast/dispatch';
import { Column, Row } from 'components/Layout/Grid';
import Input from 'components/Input';
import { Button } from 'components/Button';
import Text from 'components/Text';
import UploadService from 'services/upload.service';
import MissingLetterServices from 'services/missingLetters.service';

import ProductsTable from 'components/Table/Products';
import { IProducts } from 'models/Product';
import { productModel } from 'components/Table/Products/models';
import FileDropZone from 'components/FileDropZone';
import Form from 'components/Form';
import { GetDateToServer } from 'utils/TimeOutput';

const MissingLettersSlider = () => {
  const _uploadService = new UploadService();
  const _missingLetterServices = new MissingLetterServices();
  const dispatch = useDispatch();

  const state = useSelector((stateRoot: RootState) => stateRoot?.slider?.state);

  state?.setRefreshTable(false);

  const item = state?.item;

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>({
    file: undefined,
    name: '',
    startDate: '',
    endDate: '',
  });

  const [products, setProducts] = useState(item?.productsIds || []);

  function onSelectProduct(id: any) {
    setProducts((oldProps: any) => [
      ...oldProps?.filter((product: any) => product !== id),
    ]);
  }

  function onRemoveProduct(id: any) {
    setProducts((oldProps: any) => [...oldProps, id]);
  }

  useEffect(() => {
    if (item) {
      setData({
        ...item,
        startDate: DateOutputStr(item.startDate, 'yyyy-MM-dd'),
        endDate: DateOutputStr(item.endDate, 'yyyy-MM-dd'),
      });
    }
  }, []);

  async function uploadFile() {
    return _uploadService.upload(data.file);
  }

  async function saveFile(fileId: any) {
    await _missingLetterServices
      .create({
        fileId,
        productsIds: products,
        name: data.name,
        startDate: GetDateToServer(data.startDate),
        endDate: GetDateToServer(data.endDate),
      })
      .then(() => {
        toast.success('Carta salva com sucesso!');
        state?.setRefreshTable(true);
        setLoading(false);
        dispatch({ type: 'CLOSE_SLIDER' });
      })
      .catch(() => {
        setLoading(false);
        return toast.error('Erro ao gravar carta.');
      });
  }

  async function updateFile(fileId: any) {
    await _missingLetterServices
      .update({
        ...item,
        fileId,
        productsIds: products,
        name: data.name,
        startDate: GetDateToServer(data.startDate),
        endDate: GetDateToServer(data.endDate),
      })
      .then(() => {
        toast.success('Carta atualizada com sucesso!');
        state?.setRefreshTable(true);
        setLoading(false);
        dispatch({ type: 'CLOSE_SLIDER' });
      })
      .catch(() => {
        setLoading(false);
        return toast.error('Erro ao atualizar carta.');
      });
  }

  async function onSubmit() {
    setLoading(true);

    if (!data.file?.id) {
      await uploadFile()
        .then((result) => {
          if (data.id) updateFile(result.id);
          else saveFile(result.id);
        })
        .catch(() => {
          setLoading(false);
          return toast.error('Erro ao fazer upload do arquivo.');
        });
    } else if (data.id) await updateFile(data.file.id);
    else saveFile(data.file.id);
  }

  return (
    <Form id="missingLetterForm" onValidate={() => onSubmit()}>
      <Column className="w-100 mt-3">
        <FileDropZone data={data} setData={setData} />
        <Row className="flex-md-column mt-3">
          <Column className="flex-1 mr-3 mr-md-0 mb-md-2">
            <Text className="color-blue-gray mb-1 mb-md-2" size={12}>
              Início da Vigência
            </Text>
            <Input
              required
              onChange={(e: any) =>
                setData({ ...data, startDate: e.target.value })
              }
              type="date"
              name="Início da vigência"
              value={data.startDate}
              className="min-width-input"
            />
          </Column>
          <Column className="flex-1">
            <Text className="color-blue-gray mb-1 mb-md-2" size={12}>
              Fim da Vigência
            </Text>
            <Input
              required
              name="Fim da vigência"
              onChange={(e: any) =>
                setData({ ...data, endDate: e.target.value })
              }
              type="date"
              value={data.endDate}
              className="min-width-input"
            />
          </Column>
          <Column className="flex-2" />
        </Row>
        <ProductsTable
          model={[
            {
              label: '',
              Component: (productTable: IProducts) => (
                <Row className="px-2">
                  <input
                    type="checkbox"
                    onClick={() =>
                      products?.find(
                        (product: any) => product === productTable.id
                      )
                        ? onSelectProduct(productTable.id)
                        : onRemoveProduct(productTable.id)
                    }
                    value={productTable.id}
                    defaultChecked={products?.find(
                      (product: any) => product === productTable.id
                    )}
                  />
                </Row>
              ),
              size: 40,
              maxSize: 40,
            },
            ...productModel,
          ]}
          showCards={false}
          className=" pb-3 pb-md-0 "
        />
        <Row className="mt-3 justify-center">
          <Button
            // onClick={onSubmit}
            className="outline"
            isRequesting={loading}
            spinnerColorClass="color-primary"
            width="auto"
            form="missingLetterForm"
          >
            <Text className="font-bold color-primary py-2 px-3">
              Gravar Arquivo
            </Text>
          </Button>
        </Row>
      </Column>
    </Form>
  );
};

export default MissingLettersSlider;
